import { PageRequest } from "@shared/zod/schemas/requests/page"
import { AuditTrailResponsePageResponse } from "@shared/zod/schemas/responses/admin"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = async (query?: PageRequest): Promise<AuditTrailResponsePageResponse> => {
  const resp = await axiosAuth({
    url: "/admin/audittrails",
    method: "get",
    params: query,
    timeout: 30_000,
  })
  return resp.data
}
